import * as moment from 'moment';
import {Cloneable} from "../../../model/common.model";

export class EmployeeTimedTaskParams  extends Cloneable{
  id: number = -1*moment().unix();
  timedTaskId: number;
  employeeId: string;
//  refDt: Date;
  scheduleId: number;
  onlyOnce = false;
  exclusive = false;
  startDt: Date;
  endDt: Date;
  note:string;
  lastName: string
  firstName: string;

  // constructor(){
  //   this.id = -1*moment().valueOf();
  // }

}
